import rpcHeaders from '#/store/headers';
import { queryAccountClient, modifyAccountClient, billingClient } from '#/clients';

export function emptyState() {
  return {

  };
}

export const getters = {

};

export const mutations = {

};

export const actions = {
  loadAccountUsers: async ({ rootState }, request) => {
    console.log('loading account users...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        queryAccountClient.listAccountUsers(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from loadAccountUsers', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('account users:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error loadAccountUsers:', error);
      return Promise.reject(error);
    }
  },
  createAccount: async ({ commit, rootState }, request) => {
    console.log('create account', request.toObject());
    try {
      const headers = await rpcHeaders(rootState, false, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.createAccount(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from createAccount', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('created account:', r);
          const { accountId, projectsList } = r.account;
          commit('addAccount', r.account, { root: true });
          for (let y = 0; y < projectsList.length; y += 1) {
            const project = { ...projectsList[y], accountId };
            commit('addProject', project, { root: true });
          }
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error createAccount:', error);
      return Promise.reject(error);
    }
  },
  createNewProject: async ({ rootState }, request) => {
    console.log('creating new project...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.createProject(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from createProject', err);
            return reject(err);
          }
          const r = response.toObject();
          // TODO: reorganize store so i dont have to modify the rootState here. remove "eslint-disable"
          // eslint-disable-next-line no-param-reassign
          rootState.projects[r.project.projectId] = r.project;
          console.log('created project:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error createNewProject:', error);
      return Promise.reject(error);
    }
  },
  inviteUser: async ({ rootState }, request) => {
    console.log('inviting new user...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.roleInviteUser(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from roleInviteUser', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('invited user:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error roleInviteUser:', error);
      return Promise.reject(error);
    }
  },
  modifyUserRole: async ({ rootState }, request) => {
    console.log('modifying user role...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.roleModifyUser(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from modifyUserRole', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('modified user:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error modifyUserRole:', error);
      return Promise.reject(error);
    }
  },
  removeUserRole: async ({ rootState }, request) => {
    console.log('removing user role...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.roleRemoveUser(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from removeUserRole', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('removed user:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error removeUserRole:', error);
      return Promise.reject(error);
    }
  },
  revokeUserInvite: async ({ rootState }, request) => {
    console.log('revoking user invite...');
    try {
      const headers = await rpcHeaders(rootState, true, false);
      return new Promise((resolve, reject) => {
        modifyAccountClient.roleRevokeUserInvite(request, headers, (err, response) => {
          if (err != null) {
            console.log('received err from roleRevokeUserInvite', err);
            return reject(err);
          }
          const r = response.toObject();
          console.log('revoked user invite:', r);
          return resolve(r);
        });
      });
    } catch (error) {
      console.log('caught error roleRevokeUserInvite:', error);
      return Promise.reject(error);
    }
  },
  loadPricingData: async ({ rootState }, request) => {
    console.log('loading cloud pricing data ');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        billingClient.retrieveCloudPricing(
          request,
          headers,
          (err, response) => {
            if (err != null) {
              console.log('Error loading pricing data ', err);
              reject(err);
            }
            const r = response.toObject();
            console.log('Pricing data', r);
            return resolve(r);
          },
        );
      });
    } catch (error) {
      console.log('caught error loading price data:', error);
      return Promise.reject(error);
    }
  },
  getBillingClientSecret: async ({ rootState }, request) => {
    console.log('getting client secret ');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        billingClient.retrieveClientSecret(
          request,
          headers,
          (err, response) => {
            if (err != null) {
              console.log('Error loading client data ', err);
              reject(err);
            }
            const r = response.toObject();
            console.log('Client data', r);
            return resolve(r);
          },
        );
      });
    } catch (error) {
      console.log('caught error loading price data:', error);
      return Promise.reject(error);
    }
  },
  getSavedPaymentMethods: async ({ rootState }, request) => {
    console.log('getting client secret ');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        billingClient.retrieveSavedPaymentMethods(
          request,
          headers,
          (err, response) => {
            if (err != null) {
              console.log('Error loading client data ', err);
              reject(err);
            }
            const r = response.toObject();
            console.log('payment data', r);
            return resolve(r);
          },
        );
      });
    } catch (error) {
      console.log('caught error loading payment data:', error);
      return Promise.reject(error);
    }
  },
  setDefaultPaymentMethod: async ({ rootState }, request) => {
    console.log('setting default payment method ');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        billingClient.setDefaultPaymentMethod(
          request,
          headers,
          (err, response) => {
            if (err != null) {
              console.log('Error setting default payment method ', err);
              reject(err);
            }
            const r = response.toObject();
            console.log('default payment set data ', r);
            return resolve(r);
          },
        );
      });
    } catch (error) {
      console.log('caught error setting default payment data:', error);
      return Promise.reject(error);
    }
  },
  deleteSavedPaymentMethod: async ({ rootState }, request) => {
    console.log('deleting saved payment method ');
    try {
      const headers = await rpcHeaders(rootState);
      return new Promise((resolve, reject) => {
        billingClient.deletePayment(
          request,
          headers,
          (err, response) => {
            if (err != null) {
              console.log('Error deleting payment method ', err);
              reject(err);
            }
            const r = response.toObject();
            return resolve(r);
          },
        );
      });
    } catch (error) {
      console.log('caught error deleting payment method:', error);
      return Promise.reject(error);
    }
  },
};

export default {
  namespaced: true,
  state: emptyState(),
  getters,
  mutations,
  actions,
};
